// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"DefaultLayout_mainContainer__1cSFi","header":"DefaultLayout_header__ZHTk3"};